import axios from "axios";
import { useState } from "react";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function useCheckout() {
  const [loading, setLoading] = useState(null);
  const buy = async (kitId) => {
    setLoading(kitId);
    try {
      const { data } = await api.post("/checkout", { kit_id: kitId });
      window.location.href = data.checkout_url;
    } catch (e) {
      const detail = e.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Could not start checkout. Try again.");
      setLoading(null);
    }
  };
  return { buy, loading };
}
